import { useEffect, useCallback, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { verifyEmail } from "../../../api/auth/account_activation"; //.
import FlashMessage from "../../../components/common/FlashMessage";

const ActivateAccount = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const [message, setMessage] = useState<string | null>(null);
  const [messageType, setMessageType] = useState<"success" | "error">(
    "success"
  );


  const handleVerifyEmail = useCallback(async () => {
    try {
      await verifyEmail(token!);
      setMessage("Conta ativada com sucesso!");
      setMessageType("success");
      setTimeout(() => navigate("/login"), 2000);
    } catch (error: any) {
      navigate("/login");
    }
  }, [token, navigate]);

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    handleVerifyEmail();
  }, [token, navigate, handleVerifyEmail]);

  return (
    <div>
      {message && (
        <div
          style={{ padding: "20px", maxWidth: "500px", margin: "20px auto" }}
        >
          <FlashMessage
            message={message}
            type={messageType}
            onClose={() => setMessage(null)}
          />
        </div>
      )}
      <p>Ativando conta...</p>
    </div>
  );
};

export default ActivateAccount;
